import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-68251de1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "popup-header"
};
const _hoisted_2 = {
  class: "header-left-wrap flex"
};
const _hoisted_3 = {
  class: "user-avatar-wrap"
};
const _hoisted_4 = {
  class: "vip-wrap"
};
const _hoisted_5 = {
  class: "user-info-wrap"
};
const _hoisted_6 = {
  class: "header-right-wrap flex justify-end"
};
const _hoisted_7 = {
  class: "close-wrap flex justify-center"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-botttom-line"
}, null, -1));
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import Balance from '@/components/Common/Balance';
import { useUserStore } from '@/store';
export default {
  __name: 'PopupHeader',
  props: ['ruleIcon', 'recordIcon'],
  emits: ['onClose', 'clickRule', 'clickRecord'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const userStore = useUserStore();
    const {
      avatar,
      vip
    } = storeToRefs(userStore);
    const showService = ref(false);
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_Service = _resolveComponent("Service");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_image, {
        class: "user-avatar",
        fit: "cover",
        src: _unref(avatar) || require('@/assets/img/user/avatar-default.png')
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(vip)), 1)]), _createElementVNode("div", _hoisted_5, _toDisplayString(`Lv.${_unref(vip)}`), 1), _createVNode(_unref(Balance), {
        onOnClose: _cache[0] || (_cache[0] = $event => emit('onClose'))
      })]), _createElementVNode("div", _hoisted_6, [__props.ruleIcon ? _withDirectives((_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        class: "header-action-btn",
        fit: "contain",
        src: require('@/assets/img/common/help.png'),
        onClick: _cache[1] || (_cache[1] = $event => emit('clickRule'))
      }, null, 8, ["src"])), [[_directive_audio]]) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_van_image, {
        class: "header-action-btn",
        fit: "contain",
        src: require('@/assets/img/common/service.png'),
        onClick: _cache[2] || (_cache[2] = $event => showService.value = true)
      }, null, 8, ["src"]), [[_directive_audio]]), __props.recordIcon ? _withDirectives((_openBlock(), _createBlock(_component_van_image, {
        key: 1,
        class: "header-action-btn",
        fit: "contain",
        src: require('@/assets/img/common/record.png'),
        onClick: _cache[3] || (_cache[3] = $event => emit('clickRecord'))
      }, null, 8, ["src"])), [[_directive_audio]]) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_withDirectives(_createVNode(_component_van_image, {
        class: "close-icon",
        src: require('@/assets/img/common/close.png'),
        onClick: _cache[4] || (_cache[4] = $event => emit('onClose'))
      }, null, 8, ["src"]), [[_directive_audio, void 0, "close"]])])]), _hoisted_8]), _createVNode(_component_Service, {
        show: showService.value,
        onOnClose: _cache[5] || (_cache[5] = $event => showService.value = false)
      }, null, 8, ["show"])], 64);
    };
  }
};